module.exports = __webpack_public_path__ + "media/store/fonts/ft-menu-1-c79026ef748a4c4f3ec5059f3ca5c36c.woff";